module.exports = __webpack_public_path__ + "img/google.bf7d0393.svg";